<div class="subgroup">
  @if (subGroup?.isTable && !modernTable) {
  <div>
    <table-column-toggle [questions]="subGroup.questions"></table-column-toggle>
  </div>
  }

  <div
    class="ui grid subgroup-card"
    [ngClass]="{ collapsed: isCollapsed }"
    id="card{{ groupId }}-{{ subGroup?.id }}"
    [hidden]="hideEmptyQuestions && subGroupHasEmptyQuestions()"
  >
    <div
      (click)="initSubGroup($event, true)"
      class="row card-header no-select"
      [ngClass]="{ active: isActive }"
      [hidden]="isFullScreenMode"
    >
      <div class="fifteen wide column">
        <span class="card-ref">{{ subGroup?.hash }}</span>
        <h3>{{ subGroup?.name }}</h3>
        <span>{{ subGroup?.hint }}</span>
        <p>{{ labelTitle }}</p>

        @if (isCollapsed) {
        <div class="dots">
          @if (hasNotification('answerWarnings', null, subGroup)) {
          <div
            class="dot warning"
            [ngClass]="{
              active: hasNotification(
                'answerWarnings',
                null,
                subGroup,
                null,
                true
              )
            }"
          ></div>
          } @if (hasNotification('answerFlags', null, subGroup)) {
          <div
            class="dot flag"
            [ngClass]="{
              active: hasNotification('answerFlags', null, subGroup, null, true)
            }"
          ></div>
          } @if (hasNotification('comments', null, subGroup)) {
          <div class="dot comment"></div>
          }
        </div>
        }
      </div>

      <div class="one wide column right aligned">
        <i
          class="chevron icon"
          [ngClass]="{ up: !isCollapsed, down: isCollapsed }"
        ></i>
      </div>
    </div>

    @if (!subGroup.isTable) {
    <div
      (click)="initSubGroup($event, false)"
      class="row card-questions"
      [@cardAnimation]="isCollapsed"
    >
      <div class="column">
        <div class="card-questions">
          @for (question of subGroup?.questions; track question) {
          <div
            class="question"
            [hidden]="hideEmptyQuestions && questionIsEmpty(question)"
            id="{{ 'question-' + question.id }}"
          >
            <app-form-field-wrapper
              [formGroup]="formGroup"
              [groupId]="groupId"
              [subGroup]="subGroup"
              [questions]="subGroup?.questions"
              [question]="question"
              [labelClick]="labelClick"
              [labelTitle]="labelTitle"
              [hasNotification]="hasNotification"
              [hideClearOverRideQuestionIcon]="hideClearOverRideQuestionIcon"
              [disabled]="
                isQuestionAlwaysEditable(question, readonly || deleted)
              "
              (refreshTaxReturn)="refreshTaxReturn.emit(true)"
              [inputQuestionId]="inputQuestionId"
            >
            </app-form-field-wrapper>
          </div>
          }
        </div>
      </div>
    </div>
    } @if (!modernTable && subGroup.isTable) {
    <div
      (click)="initSubGroup($event, false)"
      class="table-group"
      [ngClass]="{ 'read-only': readOnlyTable(), deleted: deleted }"
      [@cardAnimation]="isCollapsed"
    >
      <div
        #tableScrollContainer
        class="table-container"
        (scroll)="onTableScroll($event)"
      >
        <table cellpadding="0" cellspacing="0" class="sticky-header">
          <thead>
            <tr>
              <th (click)="newRow()" class="row-num">
                <div
                  class="add icon  add-new-table-row"
                  title="Add New Row"
                ></div>
              </th>
              @for (question of subGroup.questions; track question) { @if
              (!question.hidden && !question.toggleOff) {
              <th
                title="{{ question?.question }}"
                [ngClass]="{
                  'checkbox-column': isBooleanCheckboxColumn(question)
                }"
              >
                @if (question?.mandatory) {
                <span class="column-mandatory" title="This column is mandatory"
                  >*</span
                >
                }
                <div class="text-ellipsis">{{ question?.question }}</div>
                @if (question?.showTag) {
                <span>
                  {{ "taxReturns.tag" | transloco }}
                  {{ question?.showTag }})</span
                >
                }@if (question?.debugLinks) {
                <span
                  >{{ "taxReturns.link" | transloco }}
                  <span
                    class="link"
                    (click)="goToSection('questions', question.id)"
                  >
                    {{ "taxReturns.question" | transloco }} </span
                  >-<span
                    class="link"
                    (click)="goToSection('calculations', question.id)"
                  >
                    {{ "taxReturns.calc" | transloco }}</span
                  >)</span
                >
                }
              </th>
              } }
            </tr>
          </thead>
          <tbody class="">
            @for (rowAnswer of subGroup.rows; track rowAnswer; let index =
            $index) {
            <app-question-table-row
              [rowAnswer]="rowAnswer"
              [deleted]="deleted"
              [inspectMode]="inspectMode"
              [subGroup]="subGroup"
              [formGroup]="formGroup"
              [groupId]="groupId"
              [fullScreenSubGroup]="fullScreenSubGroup"
              [rowIndex]="index"
              [readonly]="readOnlyTable()"
              [readonlyGlobal]="readonly"
              [isSelected]="subGroup.activeRow === index"
              [hideClearOverRideQuestionIcon]="hideClearOverRideQuestionIcon"
              (loadTrace)="loadTrace.emit($event)"
              (selectRow)="selectRow($event)"
              (refreshTaxReturn)="refreshTaxReturn.emit(true)"
            ></app-question-table-row>
            }
          </tbody>
        </table>
        @if (!subGroup.rows || subGroup.rows?.length <= 0) {
        <p class="empty-message">
          {{ "taxReturns.there-is-no-data-in-this-table" | transloco }}
        </p>
        }
      </div>
    </div>
    } @if (modernTable && subGroup.isTable) {
    <div
      (click)="initSubGroup($event, false)"
      class="table-group"
      [@cardAnimation]="isCollapsed"
      id="{{ 'question-' + subGroup.id }}"
    >
      @if ( subGroup.question.dataType === 'table' &&
      subGroup.question.displayFieldType !== 'table' ) {
      <div>
        <div class="chart-table-tabs" [class.fullTabs]="isFullScreenMode">
          <div
            class="tab"
            [ngClass]="{ active: chartOptionTab == 'chart' }"
            (click)="toggleChartTable('chart')"
          >
            {{ "taxReturns.chart" | transloco }}
          </div>
          <div
            class="tab"
            [ngClass]="{ active: chartOptionTab == 'table' }"
            (click)="toggleChartTable('table')"
          >
            {{ "taxReturns.table" | transloco }}
          </div>
        </div>
        @if (viewChart) {
        <div>
          <app-chart
            [chartData]="columnOrdering"
            [chartTypeName]="subGroup.question.displayFieldType"
          ></app-chart>
        </div>
        }
      </div>
      } @if (subGroup.question.displayFieldType === 'table' || !viewChart) {
      <div>
        <app-modern-table
          (modernTableScroll)="modernTableScroll.emit($event)"
          (modernTableScrollRefEmitter)="
            modernTableScrollRefEmitter.emit($event)
          "
          [tableScrollContainerRef]="tableScrollContainerRef"
          [columnOrdering]="columnOrdering"
          [subGroup]="subGroup"
          [deleted]="deleted"
          [inspectMode]="inspectMode"
          [formGroup]="formGroup"
          [groupId]="groupId"
          [readonly]="readOnlyTable()"
          [readonlyGlobal]="readonly"
          [hideClearOverRideQuestionIcon]="hideClearOverRideQuestionIcon"
          [debugMode]="debugMode"
          [taxReturnId]="taxReturnId"
          [isVisible]="isVisible"
          (loadTrace)="loadTrace.emit($event)"
          (selectRow)="selectRow($event)"
          (refreshTaxReturn)="refreshTaxReturn.emit(true)"
          (addNewRow)="newRow()"
          (toggleFullScreen)="toggleFullScreen.emit($event)"
          (handleAside)="handleSideOpen($event)"
          (handleSaveTable)="handleSaveTable.emit($event)"
          [sideOpen]="sideOpen"
          [isFullScreenMode]="isFullScreenMode"
          [inputQuestionId]="inputQuestionId"
        ></app-modern-table>
      </div>
      }
    </div>
    }
  </div>
</div>
